import React from "react";

import Section from "../../../HOC/Section";

const Kvkk = () => {
  return (
    <Section id="kvkk">
      <div className="container pt-2 pb-5">
        <div className="section-header pt-5 pb-5 text-center">
          <h3 className="section-title">
            <span>KVKK </span>
          </h3>
          <div class="accordion accordion-flush" id="accordionFlushExample">
            <div class="accordion-item">
              <h5 class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                  KVKK Aydınlatma Metni
                </button>
              </h5>
              <div
                id="flush-collapseOne"
                class="accordion-collapse collapse"
                data-bs-parent="#accordionFlushExample"
              >
                <div class="accordion-body">
                  <div class="inner-post-entry entry-content">
                    <h5 class="wp-block-heading">
                      <strong>
                        Kişisel Verilerin İşlenmesine İlişkin Aydınlatma Metni
                      </strong>
                    </h5>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        Güzellik merkezleri ve rehabilitasyon merkezlerinin, 3.
                        kişiler ve çalışanlarına yönelik ellerinde
                        bulundurdukları yahut işlemiş oldukları verileri “özel
                        nitelikli veri” olarak adlandırılmaktadır. Özel
                        nitelikli kişisel veriler öğrenilmesi halinde ilgili
                        kişi hakkında ayrımcılık yapılmasına veya mağduriyete
                        neden olabilecek nitelikteki verilerdir. Bu nedenle,
                        diğer kişisel verilere göre çok daha sıkı şekilde
                        korunmaları gerekmektedir. Özel nitelikli kişisel
                        veriler ilgili kişinin açık rızası ile ya da Kanunda
                        sayılan sınırlı hallerde işlenebilir.
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        Kanunda özel nitelikli kişisel veriler, sınırlı sayma
                        yoluyla belirlenmiştir. Bunlar; kişilerin ırkı, etnik
                        kökeni, siyasi düşüncesi, felsefi inancı, dini, mezhebi
                        veya diğer inançları, kılık ve kıyafeti, dernek, vakıf
                        ya da sendika üyeliği, sağlığı, cinsel hayatı, ceza
                        mahkûmiyeti ve güvenlik tedbirleriyle ilgili verileri
                        ile biyometrik ve genetik verileridir. Özel nitelikli
                        kişisel verilerin kıyas yoluyla genişletilmesi mümkün
                        değildir.
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        6698 sayılı Kişisel Verilerin Korunması Kanununun
                        (Kanun) 6 ncı maddesinin (4) numaralı fıkrasında, “
                        <em>
                          Özel nitelikli kişisel verilerin işlenmesinde, ayrıca
                          Kurul tarafından belirlenen yeterli önlemlerin
                          alınması şarttır.
                        </em>
                        ” hükmü yer almaktadır.
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        Bu çerçevede, Kanunun 22 nci maddesinin (1) numaralı
                        fıkrasının (ç) ve (e) bentleri uyarınca özel nitelikli
                        kişisel veri işleyen veri sorumluları tarafından
                        alınması gereken yeterli önlemler Kişisel Verileri
                        Koruma Kurulu tarafından aşağıdaki şekilde
                        belirlenmiştir:
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        1- Özel nitelikli kişisel verilerin güvenliğine yönelik
                        sistemli, kuralları net bir şekilde belli, yönetilebilir
                        ve sürdürülebilir ayrı bir politika ve prosedürün
                        belirlenmesi,
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        2- Özel nitelikli kişisel verilerin işlenmesi
                        süreçlerinde yer alan çalışanlara yönelik,
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        a) Kanun ve buna bağlı yönetmelikler ile özel nitelikli
                        kişisel veri güvenliği konularında düzenli olarak
                        eğitimler verilmesi,
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        b) Gizlilik sözleşmelerinin yapılması,
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        c) Verilere erişim yetkisine sahip kullanıcıların, yetki
                        kapsamlarının ve sürelerinin net olarak tanımlanması,
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        ç) Periyodik olarak yetki kontrollerinin
                        gerçekleştirilmesi,
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        d) Görev değişikliği olan ya da işten ayrılan
                        çalışanların bu alandaki yetkilerinin derhal
                        kaldırılması. Bu kapsamda, veri sorumlusu tarafından
                        kendisine tahsis edilen envanterin iade alınması,
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        3- Özel nitelikli kişisel verilerin işlendiği, muhafaza
                        edildiği ve/veya erişildiği ortamlar, elektronik ortam
                        ise
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        a) Verilerin kriptografik yöntemler kullanılarak
                        muhafaza edilmesi,
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        b) Kriptografik anahtarların güvenli ve farklı
                        ortamlarda tutulması,
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        c) Veriler üzerinde gerçekleştirilen tüm hareketlerin
                        işlem kayıtlarının güvenli olarak loglanması,
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        ç) Verilerin bulunduğu ortamlara ait güvenlik
                        güncellemelerinin sürekli takip edilmesi, gerekli
                        güvenlik testlerinin düzenli olarak
                        yapılması/yaptırılması, test sonuçlarının kayıt altına
                        alınması,
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        d) Verilere bir yazılım aracılığı ile erişiliyorsa bu
                        yazılıma ait kullanıcı yetkilendirmelerinin yapılması,
                        bu yazılımların güvenlik testlerinin düzenli olarak
                        yapılması/yaptırılması, test sonuçlarının kayıt altına
                        alınması,
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        e) Verilere uzaktan erişim gerekiyorsa en az iki
                        kademeli kimlik doğrulama sisteminin sağlanması,
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        4- Özel nitelikli kişisel verilerin işlendiği, muhafaza
                        edildiği ve/veya erişildiği ortamlar, fiziksel ortam ise
                      </span>
                    </p>
                    <div
                      data-pagespeed="true"
                      data-advert="temedya"
                      data-channel="121"
                      id="ad_121"
                    ></div>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        a) Özel nitelikli kişisel verilerin bulunduğu ortamın
                        niteliğine göre yeterli güvenlik önlemlerinin (elektrik
                        kaçağı, yangın, su baskını, hırsızlık vb. durumlara
                        karşı) alındığından emin olunması,
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        b) Bu ortamların fiziksel güvenliğinin sağlanarak
                        yetkisiz giriş çıkışların engellenmesi,
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        5- Özel nitelikli kişisel veriler aktarılacaksa
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        a) Verilerin e-posta yoluyla aktarılması gerekiyorsa
                        şifreli olarak kurumsal e-posta adresiyle veya Kayıtlı
                        Elektronik Posta (KEP) hesabı kullanılarak aktarılması,
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        b) Taşınabilir Bellek, CD, DVD gibi ortamlar yoluyla
                        aktarılması gerekiyorsa kriptografik yöntemlerle
                        şifrelenmesi ve kriptografik anahtarın farklı ortamda
                        tutulması,
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        c) Farklı fiziksel ortamlardaki sunucular arasında
                        aktarma gerçekleştiriliyorsa, sunucular arasında VPN
                        kurularak veya sFTP yöntemiyle veri aktarımının
                        gerçekleştirilmesi,
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        ç) Verilerin kağıt ortamı yoluyla aktarımı gerekiyorsa
                        evrakın çalınması, kaybolması ya da yetkisiz kişiler
                        tarafından görülmesi gibi risklere karşı gerekli
                        önlemlerin alınması ve evrakın “gizlilik dereceli
                        belgeler” formatında gönderilmesi gerekir.
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        6- Yukarıda belirtilen önlemlerin yanı sıra Kişisel
                        Verileri Koruma Kurumunun internet sitesinde yayımlanan
                        Kişisel Veri Güvenliği Rehberinde belirtilen uygun
                        güvenlik düzeyini temin etmeye yönelik teknik ve idari
                        tedbirler de dikkate alınmalıdır.
                      </span>
                    </p>

                    <p>
                      <span style={{fontSize:"16px"}}>
                        Hem cezai hem de idari yaptırımlarla koruma altına
                        alınan kişisel verilerin korunması hukuku, kuruluşlar
                        açısından da oldukça önem arz etmektedir. Tüm bu
                        sebeplerle, bahsi geçen kuruluşların “veri işlenmesi ve
                        saklanması” hususlarında kanun hükümleri doğrultusunda
                        hareket etmeleri gerekmektedir. Aksi halde veri
                        ihlalleri ortaya çıkacak ve bu ihlaller, yukarıda da
                        açıklandığı üzere, kurumlar açısından oldukça kritik
                        sonuçlar doğuracaktır.
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
           
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Kvkk;
